module.exports = __webpack_public_path__ + "static/media/stones-gb0e46b024_640.05fb8b08.jpg";